import { twc } from 'util/cn'

const NoQueryResult = twc.div`text-ellipsis break-all text-md font-semibold text-label-l1`

export default NoQueryResult
